// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"471":"409b3a2c","479":"409b3a2c","1040":"409b3a2c","2604":"409b3a2c","5054":"409b3a2c","6610":"38e3afee","7680":"409b3a2c","8655":"409b3a2c","8953":"409b3a2c","9700":"409b3a2c"}[chunkId] + ".chunk.css";
};